import type { FC } from "react";
import React, { useContext } from "react";
import cn from "classnames";

import { useAppSelector } from "@litres-core/store";
import { useTranslation } from "@litres-libs/i18n";
import { SmartLink } from "@litres-modules/smart-link";
import { HeaderContext } from "../../Header";
import { MobileOperatorLogo } from "../MobileOperatorLogo/MobileOperatorLogo";
import { MainLogo } from "./MainLogo";

import styles from "./Logo.module.scss";

interface ILogoProps {
  pathname?: string;
}

export const Logo: FC<ILogoProps> = ({ pathname }) => {
  const { t } = useTranslation();
  const isDesktop = useAppSelector(state => !state.browser.pda);

  const { isLibraryDomain, isSchoolDomain, isMobileOperatorDomain } =
    useContext(HeaderContext);

  const getLogo = (): JSX.Element => {
    if (isLibraryDomain || isSchoolDomain) {
      return (
        <img
          src="https://cdn.litres.ru/static/litres/logo/logo_library.svg"
          width={isDesktop ? 196 : 100}
          height={40}
          alt={t("Логотип Литрес:Библиотеки")}
        />
      );
    }

    if (isDesktop && isMobileOperatorDomain) {
      return <MobileOperatorLogo />;
    }

    return <MainLogo />;
  };

  return (
    <SmartLink
      className={cn(styles.wrapper)}
      data-testid="header--logo"
      style={{
        cursor: pathname === "/" ? "auto" : "pointer",
      }}
      href={pathname === "/" ? undefined : "/"}
      aria-label={t("Главная страница Литрес")}
      tabIndex={0}
    >
      {getLogo()}
    </SmartLink>
  );
};
